import { render, staticRenderFns } from "./VFormCheckbox.vue?vue&type=template&id=561f380c&"
import script from "./VFormCheckbox.vue?vue&type=script&lang=js&"
export * from "./VFormCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VFormCheckbox.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports